import { faMagnifyingGlass } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { styled } from 'styled-components'

import { Button, FormattedMessage } from '@b-stock/fe-core/bstock-react'
import { designColors } from '@b-stock/fe-core/theme'

const NoResultsContainer = styled.div`
  padding-top: 1rem;
`

const NoResultsDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

const NoResultsComponents = styled.div`
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
`

const StyledIcon = styled(FontAwesomeIcon)`
  background-color: ${designColors.neutral.lightGray};
  border-radius: 50%;
  padding: 0.5rem;
`

type NoResultsTableBodyProps = {
  resetFilters: () => void
}

const NoResultsTableBody = ({ resetFilters }: NoResultsTableBodyProps) => {
  return (
    <NoResultsContainer>
      <NoResultsDiv>
        <NoResultsComponents>
          <StyledIcon icon={faMagnifyingGlass} />
        </NoResultsComponents>
        <NoResultsComponents>
          <FormattedMessage id="ManifestTable.noResultsBody.noResultsFound" />
        </NoResultsComponents>
        <NoResultsComponents>
          <Button appearance="plainTertiary" onClick={resetFilters}>
            <FormattedMessage id="ManifestTable.noResultsBody.resetSearchFilters" />
          </Button>
        </NoResultsComponents>
      </NoResultsDiv>
    </NoResultsContainer>
  )
}

export default NoResultsTableBody
